/**
 * Formulário de leads com envio direto ao Salesforce (Web-to-Lead).
 *
 * Port do LeadFormModal do site novo (Astro):
 * site-edify-astro/src/components/functional/LeadFormModal.jsx
 * Mesmos campos, valores, mapeamentos e padrão de envio.
 *
 * Markup gerado por portaledify_sf_leads_fields() (inc/functions_lead-fields.php).
 * Constantes/mapas/validadores do Salesforce ficam em ../Utils/sfLead.js.
 */
import CustomMask from "../Utils/CustomMask";
import {
    buildSfLeadParams,
    clearFieldError,
    sfValidators,
    submitSfLead,
    validateFields,
} from "../Utils/sfLead";

const VALIDATORS = {
    name: sfValidators.name,
    email: sfValidators.email,
    mobile_phone: sfValidators.phone,
    "escola-name": (v) => {
        if (!v) return "Nome da escola é obrigatório";
        if (v.length < 3) return "Nome da escola deve ter no mínimo 3 caracteres";
        return null;
    },
    state: sfValidators.required("Estado é obrigatório"),
    city: sfValidators.required("Cidade é obrigatória"),
    cf_perfil_da_escola: sfValidators.required("Rede de ensino é obrigatória"),
    escola_parceira: sfValidators.required("Este campo é obrigatório"),
    cf_cargo_do_lead: sfValidators.required("Relação com a escola é obrigatória"),
    cf_growth_campo_de_intencao: sfValidators.required("Este campo é obrigatório"),
    cf_quantos_alunos_tem_a_sua_escola: sfValidators.required("Número de alunos é obrigatório"),
    cf_qual_e_a_mensalidade_da_sua_escola: sfValidators.required("Valor da mensalidade é obrigatório"),
};

// Municípios por UF — carregado uma única vez sob demanda
let municipiosPromise = null;
const loadMunicipios = (url) => {
    if (!municipiosPromise) {
        municipiosPromise = fetch(url)
            .then((response) => response.json())
            .catch(() => {
                municipiosPromise = null;
                return {};
            });
    }
    return municipiosPromise;
};

function initSfLeadForm(form) {
    const $form = $(form);

    new CustomMask(["(00) 00000-0000", "(00) 0000-00009"], $form.find("input[name='mobile_phone']"));

    // Revalida o campo ao corrigir (limpa o erro assim que o valor fica válido)
    $form.on("input change", "[name]", function () {
        const $field = $(this);
        const validator = VALIDATORS[$field.attr("name")];
        if (!validator) return;
        if (!validator(($field.val() || "").trim())) clearFieldError($field);
    });

    // Datalist de cidades muda conforme o estado escolhido (municípios do IBGE
    // agrupados por UF, mesmo JSON usado pelo site novo)
    const $state = $form.find("select[name='state']");
    const $city = $form.find("input[name='city']");
    const $cityList = $form.find("datalist");

    $state.on("change", function () {
        const uf = $(this).find("option:selected").data("uf");
        $city.val("");

        if (!uf) {
            $city.prop("disabled", true).attr("placeholder", "Escolha o estado primeiro");
            $cityList.empty();
            return;
        }

        loadMunicipios($city.data("municipios")).then((municipiosPorUf) => {
            $cityList.empty();
            (municipiosPorUf[uf] || []).forEach((cidade) => {
                $("<option>").attr("value", cidade).appendTo($cityList);
            });
            $city.prop("disabled", false).attr("placeholder", "Digite ou selecione a cidade");
        });
    });

    $form.on("submit", function (event) {
        event.preventDefault();

        if (!validateFields($form, VALIDATORS)) return;

        const $submit = $form.find("[type='submit']");
        $submit.prop("disabled", true);

        const value = (name) => ($form.find("[name='" + name + "']").val() || "").trim();

        const uf = $state.find("option:selected").data("uf") || value("state");

        const params = buildSfLeadParams({
            name: value("name"),
            email: value("email"),
            mobile: value("mobile_phone"),
            company: value("escola-name"),
            city: value("city"),
            state: uf,
            origem: value("sf-origem"),
            cargo: value("cf_cargo_do_lead"),
            rede: value("cf_perfil_da_escola"),
            momento: value("cf_growth_campo_de_intencao"),
            escolaParceira: value("escola_parceira"),
            rangeAlunos: value("cf_quantos_alunos_tem_a_sua_escola"),
            rangeMensalidade: value("cf_qual_e_a_mensalidade_da_sua_escola"),
            descriptionLines: [
                "Escola parceira: " + value("escola_parceira"),
                "Relação com a escola: " + value("cf_cargo_do_lead"),
                "Rede de ensino: " + value("cf_perfil_da_escola"),
                "Nº de alunos: " + value("cf_quantos_alunos_tem_a_sua_escola"),
                "Mensalidade média: " + value("cf_qual_e_a_mensalidade_da_sua_escola"),
                "Momento do bilíngue: " + value("cf_growth_campo_de_intencao"),
                "Cidade/UF: " + value("city") + "/" + uf,
            ],
        });

        submitSfLead(params)
            .then(() => {
                if (typeof dataLayer !== "undefined") dataLayer.push({ event: "gtm.formSubmit" });

                const redirect = $form.data("redirect");
                if (redirect && String(redirect).trim()) {
                    window.location.href = String(redirect).trim();
                    return;
                }

                $form.closest(".sf-lead-form-wrapper").find(".sf-lead-form-inner").hide();
                $form
                    .closest(".sf-lead-form-wrapper")
                    .find(".sf-lead-feedback")
                    .html(
                        '<i class="fa-solid fa-circle-check mb-4" style="color: #63E6BE; font-size: 5rem"></i>' +
                            '<h3 class="h3">Recebemos seus dados!<br/>Nosso time entrará em contato em breve.</h3>'
                    );
            })
            .catch(() => {
                $submit.prop("disabled", false);
                $form
                    .find(".sf-lead-error")
                    .text("Erro ao enviar. Tente novamente.")
                    .removeClass("d-none");
            });
    });
}

$(function () {
    $(".sf-lead-form").each(function () {
        initSfLeadForm(this);
    });
});
